import { BaseComponent } from '../../components/base-component'
import { SidebarFiltersMobile } from './sidebar-filters-mobile'
import { $elParent } from 'src/scripts/utils/utils'

const SIDEBAR_COMPONENT_SELECTOR = '#SidebarFiltersMobile'

export class FiltersSubmitBtn extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()

    const sidebar: SidebarFiltersMobile = $elParent(
      SIDEBAR_COMPONENT_SELECTOR,
      this,
    )

    if (sidebar) {
      sidebar.hide()
    }
  }
}
